import styled from '@emotion/styled';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
`;

export const Left = styled.div`
  width: 30%;
  background-color: #fbfcfc;
  overflow: auto;
`;

export const Right = styled.div`
  width: 70%;
  display: flex;
  position: relative;
`;

export const SkeletonsWrapper = styled.div`
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AppliedFiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: auto;
`;

export const AppliedFilterChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  color: #111827;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
`;

// ##################################################################### //
// ######################## Bottom Sheet Styles ######################## //
// ##################################################################### //

export const HeaderContainer = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
`;

export const ContentWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SorterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #edeef2;
`;

export const ContentBody = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const BottomSheetFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  position: sticky;
  bottom: 0;
  background: #ffffff;
  width: 100%;
  padding: 12px;
`;
